import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageCodes } from '../../common/types/i18n';

const initialState = {
  isDarkMode: false,
  isRtl: true,
  isSidebarOpen: true,
};

const displaySettingsSlice = createSlice({
  name: 'displaySettingsSlice',
  initialState,
  reducers: {
    toggleDarkMode(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem(
        'flowbite-theme-mode',
        state.isDarkMode ? 'dark' : 'light'
      );
    },
    togglePageDirection(state, action: PayloadAction<LanguageCodes>) {
      state.isRtl = action.payload === LanguageCodes.AR;
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const { toggleDarkMode, togglePageDirection, toggleSidebar } =
  displaySettingsSlice.actions;
export default displaySettingsSlice.reducer;
